export const apiBaseUrl = `https://staging-be-examfit.workerfit.com/api/v1`;
export const frontEndApiBaseUrl = `https://staging-examfit.workerfit.com`;
